import React from 'react';
import { GetServerSideProps } from 'next';
import BusinessService from '~/api/services/businessService';

interface Props {
  slug?: string;
}

export const getServerSideProps: GetServerSideProps<Props> = async (context) => {
  try {
    const business = await BusinessService.getBusiness(context.query.channel);
    return {
      props: { slug: business?.slug },
    };
  } catch {
    return { props: {} };
  }
};

const EmbedBadge: React.FC<Props> = ({ slug }) => {
  let href = '/';
  if (slug) href += `business/${slug}`;
  return (
    /* eslint-disable react/jsx-no-target-blank */
    <a href={href} target="_blank">
      <img
        style={{ width: '100%', height: '100%', maxWidth: 300, maxHeight: 300 }}
        src={`/images/badge-featured.svg?slug=${slug}`}
      />
    </a>
  );
};

export default EmbedBadge;
